export const googleMapsApiKey = 'AIzaSyARWCDSEwGJXzP_wV_nFcIGsgB_K71uS1Q';
export const googleMapsApiOptions = {
  apiKey: googleMapsApiKey,
  libraries: [] as string[],
  language: 'cs',
  region: 'CZ',
  version: 'quarterly'
};
